import { CartesianGrid, Line, LineChart, ResponsiveContainer, Tooltip, XAxis, YAxis } from "recharts"
import { num } from "../data"
import type { Grain } from "../salesSeries"
import type { StockPoint } from "../stockSeries"
import { AXIS_TICK, PointTooltip, actionMarkers, xAxisProps } from "./chartParts"

export const STOCK = "var(--series-1)"

function lines(p: StockPoint) {
  const out = p.stock !== null ? [`Stock: ${num(p.stock)}`] : [`Expected stock: ${num(p.expected ?? 0)}`]
  if (p.landing) out.push(`Order lands: +${num(p.landing)}`)
  return out
}

// Stock level over time: a solid line for the past, a dashed line for what to
// expect once the incoming order lands.
export default function StockChart({ points, grain }: { points: StockPoint[]; grain: Grain }) {
  return (
    <ResponsiveContainer width="100%" height={220}>
      <LineChart data={points} margin={{ top: 24, right: grain === "month" ? 40 : 16, bottom: 0, left: 0 }}>
        <CartesianGrid stroke="var(--chart-grid)" vertical={false} />
        <XAxis {...xAxisProps(points, grain)} type="number" domain={[0, points.length - 1]} />
        <YAxis width={44} tick={AXIS_TICK} stroke="var(--chart-grid)" />
        <Tooltip content={<PointTooltip lines={lines} />} cursor={{ stroke: "var(--chart-axis)", strokeWidth: 1 }} />
        {actionMarkers(points)}
        <Line
          dataKey="stock"
          stroke={STOCK}
          strokeWidth={2}
          dot={grain === "day" ? false : { r: 3, fill: STOCK, strokeWidth: 0 }}
          activeDot={{ r: 5, strokeWidth: 2, stroke: "var(--card)" }}
          isAnimationActive={false}
        />
        <Line
          dataKey="expected"
          stroke={STOCK}
          strokeWidth={2}
          strokeDasharray="6 4"
          dot={false}
          activeDot={{ r: 5, strokeWidth: 2, stroke: "var(--card)" }}
          isAnimationActive={false}
        />
      </LineChart>
    </ResponsiveContainer>
  )
}
